<template>
  <section class="flex flex-col rounded-m bg-secondary-secondary">
    <h2 v-if="headline" class="paragraph-bold">
      {{ headline }}
    </h2>

    <slot />
  </section>
</template>

<script lang="ts" setup>
type PickLotteryPlaySlipCardProps = {
  headline?: string
}

defineProps<PickLotteryPlaySlipCardProps>()
</script>
